<template>
  <div class="page-shell">
    <EmptyState title="页面不存在" description="访问的页面不存在或暂未配置，请检查菜单权限与路由地址。" icon="el-icon-warning-outline">
      <el-button type="primary" @click="$router.push('/')">返回工作台</el-button>
    </EmptyState>
  </div>
</template>

<script>
import EmptyState from '@/components/EmptyState.vue'

export default {
  name: 'Error404',
  components: { EmptyState }
}
</script>
